export const APP_CODES = {
  BOT_BUILDER: 'botbuilder',
  KNOWLEDGE_BASE: 'knowledgebase',
  DOMAINS: 'domains',
  ANALYTICS: 'analytics',
  SYS_ADMIN: 'sysadmin',
  INTENT_MANAGER: 'intentmanager',
  ORG_MGMT: 'orgmgmt',
  MAVEN: 'maven',
  BOT_PLATFORM: 'botplatform',
  PERFORMANCE_OPTIMIZER: 'performanceoptimizer',
  DATA_TRANSPORTER: 'datatransporter',
  CONVERSATION_ASSIST: 'conversationassist',
  AIWB: 'aiworkbench',
};

export const APP_CODES_INVERTED = {
  botbuilder: 'BOT_BUILDER',
  knowledgebase: 'KNOWLEDGE_BASE',
  domains: 'DOMAINS',
  analytics: 'ANALYTICS',
  sysadmin: 'SYS_ADMIN',
  intentmanager: 'INTENT_MANAGER',
  orgmgmt: 'ORG_MGMT',
  maven: 'MAVEN',
  botplatform: 'BOT_PLATFORM',
  performanceoptimizer: 'PERFORMANCE_OPTIMIZER',
  datatransporter: 'DATA_TRANSPORTER',
  conversationassist: 'CONVERSATION_ASSIST',
  aiworkbench: 'AIWB',
};
